import useLocalStore from '../../../hooks/useLocalStore';
import FJPptToVideo from './FJPptToVideo';
import { useSelector } from 'react-redux';

const FJPptToVideoContainer = () => {
    const textToVideoStep = useSelector(state => state.textToVideo.textToVideoStep);
    useLocalStore();

    return <FJPptToVideo textToVideoStep={textToVideoStep} />;
};

export default FJPptToVideoContainer;
